import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import NormalAbnormal from '../NormalAbnormal'
import CustomSelect from '../CustomSelect'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import AssessmentText from '../AssessmentText'

const Gastrointestinal = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Stack gap={2} padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Gastrointestinal Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            size="small"
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
          />
        </Grid>
        <NormalAbnormal
          fieldName="Visual Examination"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Palpation"
          options={['Abdomen soft', 'Abdomen firm', 'Abdomen Rigid']}
        />
        <NormalAbnormal
          fieldName="Bowel Sounds"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Hepatomegaly"
          options={['Hepatomegaly', 'No Hepatomegaly', 'Unable to Assess']}
        />
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Splenomegaly"
          options={['Splenomegaly', 'No Splenomegaly', 'Unable to Assess']}
        />
        <AssessmentText moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Gastrointestinal', moduleValues)}
            variant="contained"
            fullWidth
            color='success'
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default Gastrointestinal
